<div class="dialog-content">
    <div class="confirmation-info">
        <h3>{{ 'client.tickets.unsendGift' | translate }}</h3>
        <p>{{ 'client.tickets.unsendGiftMessage' | translate : ({email: data.email}) }}</p>
    </div>
    <div class="button-group">
        <button mat-button class="tw-primary" [disabled]="isProcessing" (click)="confirmUnsend()">
            {{ 'client.tickets.confirm' | translate }}
        </button>
        <button mat-button class="tw-secondary" [disabled]="isProcessing" (click)="closeDialog()">
            {{ 'client.tickets.cancel' | translate }}
        </button>
    </div>
</div>
